module.exports = __webpack_public_path__ + "static/rain-db362a3f41c07bf23d366c71a3931fa1.png";